importUserInfoCtrl.$inject = ['$state', '$stateParams', 'adminApi', 'importRecord', '$scope']

export default function importUserInfoCtrl($state, $stateParams, adminApi, importRecord, $scope) {
  this.domainUuid = $stateParams.domainUuid
  this.importUuid = $stateParams.importUuid
  this.schoolDiffLoading = false
  this.userDiffLoading = false
  this.schoolDiffError = null
  this.userDiffError = null
  this.schoolDiff = null
  this.userDiff = null
  this.oldSchoolsAvailable = false
  var self = this

  if (importRecord.status === 'error') {
    this.errorMessage = importRecord.message
  } else {
    this.importRecord = importRecord
  }
  this.reuploadWithChanges = function(){
    $scope.$broadcast("ReuploadWithChanges", $stateParams.importUuid, $stateParams.domainUuid)
  }
  this.moveToLicenses = function(){
    if (self.importRecord.replace_all && self.userDiff && self.userDiff.deactivating && (self.userDiff.deactivating.length/(self.userDiff.edited.length + self.userDiff.unchanged.length)) >= 0.5) {
      var moveForward = confirm('More than half of the domain\'s active users will be deactivated. Are you sure you wish to proceed?')
      if (!moveForward) {
        return
      }
    }
    $scope.$broadcast("MoveToLicenses", $stateParams.importUuid, $stateParams.domainUuid)
  }

  this.userDiffLoaded = function(userDiff) {
    console.log('Got user diff!')
    console.log(userDiff)
    self.userDiffLoading = false
    self.userDiff = userDiff
  }

  this.schoolDiffLoaded = function(schoolDiff) {
    console.log('Got school diff!')
    console.log(schoolDiff)
    self.schoolDiffLoading = false
    self.schoolDiff = schoolDiff
    self.oldSchoolsAvailable = schoolDiff.unincluded.length > 0 || schoolDiff.unchanged.length > 0
  }
}
